import React from 'react';
import ForgeTrustIcon from '@tcs/common/components/atoms/Logo';
import useStyles from './style';
import { useLogoClick } from '@tcs/common/hooks/useLogoClick';

const CollapsedLogo = () => {
  const classes = useStyles(undefined);
  const { logoClick } = useLogoClick();

  return (
    <div className={classes.logoLink}>
      <ForgeTrustIcon data-test-id="forge-icon" logoClick={logoClick} />
    </div>
  );
};

export default CollapsedLogo;
